import { render, staticRenderFns } from "./pageFive.vue?vue&type=template&id=cb2ce738&scoped=true&"
import script from "./pageFive.vue?vue&type=script&lang=js&"
export * from "./pageFive.vue?vue&type=script&lang=js&"
import style0 from "./pageFive.vue?vue&type=style&index=0&id=cb2ce738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2ce738",
  null
  
)

export default component.exports